module.exports = __webpack_public_path__ + "img/close.bbbc2f65.svg";